<template>
  <div
    id="media"
    class="media"
  >
    <v-toolbar class="elevation-0 transparent media-toolbar">
      <v-btn-toggle>
        <v-dialog
          v-model="folder"
          max-width="500px"
          scrollable
        >
          <v-card>
            <v-card-title>
              <span>Create Folder</span>
              <v-spacer></v-spacer>
            </v-card-title>
            <v-card-text>

              <v-text-field
                label="Folder Name"
                required
              ></v-text-field>
              </v-flex>

            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                outline
                color="primary"
                @click="folder = false"
              >Close</v-btn>
              <v-btn
                outline
                color="primary"
                @click="folder = false"
              >Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog
          v-model="uploadFile"
          max-width="700px"
          scrollable
        >
          <v-card>
            <v-form
              v-model="editedItem.valid"
              ref="form"
              lazy-validation
            >
              <v-card-title>
                <span>File Upload</span>
                <v-spacer></v-spacer>
              </v-card-title>
              <v-card-text>
                <v-autocomplete
                  hint="Atleast 3 Characters required"
                  :loading="loading"
                  cache-items                 
                  flat
                  placeholder="Select only suggested User"
                  chips
                  multiple
                  label="User"
                  prepend-icon="notes"
                  v-model="editedItem.userID"
                  :items="dropUsers"
                  item-text="userName"
                  item-value="userID"
                >
                </v-autocomplete>

                <v-autocomplete                  
                  hint="Atleast 3 Characters required"
                  :loading="loading"
                  cache-items                  
                  flat
                  placeholder="Select only suggested Document Type"
                  chips
                  label="Document Type"
                  prepend-icon="notes"
                  v-model="editedItem.departmentID"
                  :items="dropDepartments"
                >
                </v-autocomplete>

                <v-autocomplete                  
                  hint="Atleast 3 Characters required"
                  :loading="loading"
                  cache-items                  
                  flat
                  placeholder="Select only suggested Category"
                  chips
                  label="Category"
                  prepend-icon="table_chart"
                  v-model="editedItem.categoryID"
                  :items="dropCategories"
                >
                </v-autocomplete>

                <v-text-field
                  v-model="editedItem.displayName"
                  label="Display Name"
                  prepend-icon="select_all"
                ></v-text-field>

                <upload-btn
                  :fileChangedCallback="fileChanged"
                  title="Upload your document"
                >
                  <template slot="icon-left">
                    <v-icon
                      left
                      color="white"
                    >attachment</v-icon>
                  </template>
                </upload-btn>
                <div class="large-12 medium-12 small-12 cell">
                  <div
                    v-for="(file, key) in uploadedFiles"
                    class="file-listing"
                  >{{ file.name }}
                    <v-btn
                      v-if="!showDownLoad"
                      icon
                      @click="removeFile( key )"
                    >
                      <v-icon>close</v-icon>
                    </v-btn>

                  </div>
                </div>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  v-if="showDownLoad"
                  outline
                  color="primary"
                  @click.native="download"
                >Download</v-btn>
                <v-btn
                  outline
                  color="primary"
                  @click.native="save"
                >Upload</v-btn>
                <v-btn
                  outline
                  color="primary"
                  @click="uploadFile = false"
                >Close</v-btn>

              </v-card-actions>
            </v-form>
          </v-card>
        </v-dialog>

        <v-btn
          flat
          @click="back"
        >
          <v-icon color="primary">replay</v-icon>
          &nbsp; Back &nbsp;
        </v-btn>
        &nbsp;
        <v-btn
          flat
          @click="openUpload"
        >
          <v-icon color="primary">cloud_upload</v-icon>
          &nbsp; Upload File
        </v-btn>
      </v-btn-toggle>
        <v-text-field
        class="mx-3"
        flat
        label="Search"
        prepend-icon="search"
        v-model="search"
        clearable
        @click:clear="clearSearch"
      ></v-text-field>
      <v-spacer></v-spacer>
      <v-btn-toggle v-model="view">
        <v-btn
          flat
          value="list"
        >
          <v-icon color="primary">view_headline</v-icon>
        </v-btn>
        <v-btn
          flat
          value="grid"
        >
          <v-icon color="primary">view_list</v-icon>
        </v-btn>
      </v-btn-toggle>
    </v-toolbar>
    <v-divider></v-divider>
    <div class="layout row media-layout">
      <div class="media-content flex transparent">
        <app-section-loader :status="loader"></app-section-loader>
        <vue-perfect-scrollbar class="media-content--warp">
          <v-container
            fluid
            v-if="view ==='grid'"
          >
            <v-layout
              row
              wrap
              class="x-grid-lg"
            >
              <v-flex
                lg4
                sm12
                xs12
                class="pa-2"
                v-for="(item,index) in filteredFolder"
                :key="'folder'+ index"
              >
                <a
                  @click="showFiles(item)"
                  class="d-flex"
                >
                  <v-card
                    flat
                    tile
                  >
                    <v-card-media height="150px">
                      <v-icon
                        size="120"
                        class="mx-auto"
                        color="primary"
                      >folder</v-icon>
                    </v-card-media>
                    <v-divider></v-divider>
                    <v-card-title>
                      {{item.text}}
                    </v-card-title>
                  </v-card>
                </a>
              </v-flex>

            </v-layout>
          </v-container>
          <v-layout
            column
            v-else
          >
            <v-list
              dense
              class="transparent"
            >
              <v-list-tile
                avatar
                @click="showDetail(item)"
                v-for="(item,index) in filteredItems"
                :key="'list-file-'+index"
              >
                <v-list-tile-avatar>
                  <v-icon color="primary">{{ mimeIcons(item) }}</v-icon>
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <div class="container pl-0">
                    <div class="layout row">
                      <div class="flex lg4 sm12 xs12"> {{item.fileName}}</div>
                      <div class="flex"> {{ item ? getDept(item.departmentID) :'' }} </div>
                      <div class="flex"> {{ item ? getCateg(item.categoryID) :'' }} </div>
                      <v-spacer></v-spacer>
                      <div class="caption">{{item ? formateDate(item.uploadDate) : ''}}</div>
                    </div>
                  </div>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-layout>
        </vue-perfect-scrollbar>

        <delete-confirmation-dialog
          ref="deleteConfirmationDialog"
          heading="Are You Sure You Want To Delete?"
          message="Are You Sure You Want To Delete This Item Permanently?"
          @onConfirm="deleteItem"
        >
        </delete-confirmation-dialog>

        <v-snackbar
          :top="y === 'top'"
          :timeout="timeout"
          v-model="snackbar"
        >
          {{ snackbarMessage }}
        </v-snackbar>
      </div>
    </div>
    <app-section-loader :status="loader"></app-section-loader>
  </div>
</template>

<script>
import Bytes from 'bytes';
import { getFileMenu, getFile } from '@/api/file';
import { getDocuments, uploadDocuments, documentUsers, downloadFile, getDocument, getUsers, createDocuments, updateDocuments, deleteDocuments } from '@/api/document';
//import { getFolders, getFolder, createFolders, updateFolders, deleteFolders } from '@/api/folder';
 import GlobalMessage from '@/constant'
import UploadButton from 'vuetify-upload-button';
//import Vue from 'vue';
//import FileUpload from 'v-file-upload';
//Vue.use(FileUpload)
export default {
  components: {
 
    'upload-btn': UploadButton
  },
  props: {
    type: {
      type: String,
      default: 'image'
    }
  },
  data: () => ({
    items: [{ title: "View", id: 1 }, { title: "Download", id: 2 }],
    snackbar: false,
    snackbarMessage: '',
    timeout: 2000,
    search: '',
    showDownLoad: false,
    folderName: '',
    loading: false,
    y: 'top',
    size: 'lg',
    view: 'grid',
    folder: false,
    uploadFile: false,
    documents: [],
    allFiles: [],
    uploadedFiles: [],
    dropUsers: [],
    dropDepartments: [
      { text: 'Glossary', value: 2 },
      { text: 'Abbreviation', value: 1 },
      { text: 'SOP Content', value: 3 },
      { text: 'SOP Appentix', value: 4 },
      { text: 'SOP TA Questions', value: 5 },
      { text: 'Certificate', value: 6 },
    ],
    dropCategories: [
      { text: 'Appendix', value: 1 },
      { text: 'Content', value: 2 },
      { text: 'Import', value: 3 },
      { text: 'Export', value: 4 },
      { text: 'Local', value: 5 },
    ],
    editFile: {
      name: '',
      size: '',
    },
    folderFfilter: false,
    editedIndex: -1,
    selectedItem: null,
    files: new FormData(),
    editedItem: {
      valid: false,
      documentAccessID: null,
      documentID: -1,
      documentAccessID: null,
      documentAccessName: null,

      displayName: '',
      wikiID: null,
      departmentID: null,
      categoryID: null,
      fileName: 'Arun.docx',
      extension: null,
      contentType: null,
      documentType: null,
      fileData: null,
      fileSize: 0,
      uploadDate: new Date(),
      sessionID: null,
      linkID: null,
      isSpecialFile: true,
      isTemp: true,
      description: '',
      uploadedFile: null
    },
    defaultItem: {
      valid: false,
      documentAccessID: null,
      documentID: -1,
      documentAccessID: null,
      documentAccessName: null,

      displayName: '',
      wikiID: null,
      departmentID: null,
      categoryID: null,
      fileName: 'Arun.docx',
      extension: null,
      contentType: null,
      documentType: null,
      fileData: null,
      fileSize: 0,
      uploadDate: new Date(),
      sessionID: null,
      linkID: null,
      isSpecialFile: true,
      isTemp: true,
      description: '',
      uploadedFile: null
    },
    imageMime: ['image/jpeg', 'image/png', 'image/svg+xml'],

    folders: [

    ]
  }),
  computed: {
    filteredItems () {
      if (!this.folderFfilter) {
        return this.allFiles.filter(item => {
          if (!this.search) return this.allFiles;
          return (item.fileName.toLowerCase().includes(this.search.toLowerCase()));

        });
      }
      else {
        this.folderFfilter = false;
        return (this.allFiles.filter(f => f.departmentID == this.folderName));
      }

    },
    filteredFolder () {
      return this.dropDepartments.filter(item => {
        if (!this.search) return this.dropDepartments;
        return (item.text.toLowerCase().includes(this.search.toLowerCase())
          // || item.fileName.toLowerCase().includes(this.search.toLowerCase())
          // || item.fileName.toLowerCase().includes(this.search.toLowerCase())
        );
      });
    }
  },
  created () {
    this.initialize();
  },
  methods: {
    clearSearch () {
      this.search = "";
    },

    getDept (value) {      let catt = this.dropDepartments.filter(c => c.value == value);

      return catt[0] ? catt[0].text : '';    },
    getCateg (value) {

      let catt = this.dropCategories.filter(c => c.value == value);

      return catt[0] ? catt[0].text : '';
    },
    back () {
      this.view = 'grid';
      this.folderName = '',
        this.folderFfilter = false;
      this.documents = this.allFiles;
    },
    download () {
      this.loader = true;
      downloadFile(this.editedItem.documentID)
        .then(response => {
          // const url = window.URL.createObjectURL(new Blob([response.data]));
          // const link = document.createElement('a');
          // link.href = url;
          // link.setAttribute('download', this.editedItem.fileName);
          // document.body.appendChild(link);
          // link.click();
          let blob = new Blob([response.data], { type: this.editedItem.contentType })
          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = this.editedItem.fileName
          link.click()
          this.loader = false;

        })
        .catch(error => {
          this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });
    },
    initialize () {
      this.loader = true;
      getDocuments('')
        .then(response => {
          this.documents = response.data;
          this.allFiles = response.data;
          this.loader = false;
          console.log(this.documents);
        })
        .catch(error => {
          this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });

      getUsers('')
        .then(response => {
          this.dropUsers = response.data;
          this.loader = false;
        })

        .catch(error => {
          this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });

    },
    editItem (item) {
      this.editedIndex = this.documents.indexOf(item);
      this.editedItem = Object.assign({}, item);
      console.log(this.editedItem);
      documentUsers(this.editedItem.documentID)
        .then(response => {
          this.editedItem.userID = response.data;
          this.loader = false;
        })
        .catch(error => {
          this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });
      this.uploadFile = false;
    },
    saveAndClose () {
      this.save();
      this.close();
    },
    openUpload () {

      this.add();
      this.uploadFile = true;
    },
    add () {
      this.uploadedFiles = [];
      this.showDownLoad = false;
      this.editedItem = Object.assign({}, this.defaultItem);
      this.editedIndex = -1;
    },
    close () {
      this.dialog = false;
      this.initialize();
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    onDeleteItem (item) {
      this.$refs.deleteConfirmationDialog.openDialog();
      this.editedItem = item;
    },
    deleteItem () {
      this.$refs.deleteConfirmationDialog.close();
      // this.loader = true;
      let index = this.editedIndex;
      console.log(this.editedItem);
      deleteDocuments(this.editedItem)
        .then(() => {
          this.add();
          this.documents.splice(index, 1);
          window.getApp.$emit('APP_API_SUCCESS', GlobalMessage.DELETE);
        })
        .catch(error => {
          //this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });
    },
    save () {
      console.log(this.editedItem);
      if (this.$refs.form.validate()) {
        this.loader = true;
        let index = this.editedIndex;
        if (this.editedIndex > -1) {
          Object.assign(this.documents[this.editedIndex], this.editedItem);
          this.editedItem.modifiedByUserID = this.$store.state.auth.userId;
          this.editedItem.modifiedDate = new Date();
          this.editedItem.addedByUserID = this.$store.state.auth.userId;
          this.editedItem.addedDate = new Date();
          updateDocuments(this.editedItem)
            .then(response => {
              Object.assign(this.documents[index], response.data);
              this.uploadFile = false;
              this.loader = false;
              window.getApp.$emit('APP_API_SUCCESS', GlobalMessage.UPDATE);
            })
            .catch(error => {
              this.loader = false;
              window.getApp.$emit('APP_API_ERROR', error);
            });
        } else {
          this.editedItem.documentID = parseInt(Math.random() * 100) + 1024; // mock a id           
          this.editedItem.addedByUserID = this.$store.state.auth.userId;
          this.editedItem.addedDate = new Date();
          this.editedItem.statusCodeID = 1;
          uploadDocuments(this.files)
            .then(response => {
              this.editedItem.sessionID = response.data;
              updateDocuments(this.editedItem)
                .then(response => {
                  this.uploadFile = false;
                  this.documents.push(response.data);
                  this.loader = false;
                  
                  this.editedItem = response.data;
                  let index = this.documents.map(item => item.documentID).indexOf(response.data.documentID)
                  this.editedIndex = index;
                  window.getApp.$emit('APP_API_SUCCESS', GlobalMessage.UPDATE);
                })
                .catch(error => {
                  this.loader = false;
                  window.getApp.$emit('APP_API_ERROR', error);
                });
            })
            .catch(error => {
              this.loader = false;
              window.getApp.$emit('APP_API_ERROR', error);
            });

        }
        //this.close();
      }
    },

    toolfunction () {

      getDocument(this.searchItem)
        .then(response => {

          if (response.data.documentID != null) {

            this.editedItem = response.data;
            let index = this.documents.map(item => item.documentID).indexOf(response.data.documentID)
            this.editedIndex = index;

          }
          else {
            window.getApp.$emit('APP_API_SUCCESS', 'No More Record to View');
          }

        })
        .catch(error => {
          // this.loader = false;
         window.getApp.$emit('APP_API_ERROR', error);
        });
    },

    fileChanged (file) {

      this.editedItem.fileName = file.name;
      this.editedItem.fileSize = file.size;
      this.editedItem.contentType = file.type;
      this.files.append("file", file, file.name);
      this.uploadedFiles.push(file);
      // this.editedItem.uploadedFile = this.files;
      //  uploadDocuments(this.files)
      //       .then(response => {
      //        console.log(response.data);
      //       })
      //       .catch(() => {


      //       });
    },
    removeFile (key) {

      //have to remove files array which is handle at this movement 

      this.uploadedFiles.splice(key, 1);
    },
    isImage (file) {
      return this.imageMime.includes(file.fileType);
    },
    mimeIcons (file) {
      return this.imageMime.includes(file.fileType)
        ? 'image'
        : 'insert_drive_file';
    },
    showDetail (file) {
      this.uploadedFiles = [];
      this.editedIndex = this.documents.indexOf(file);
      this.editedItem = Object.assign({}, file);
      this.showDownLoad = true;
      this.editFile.name = this.editedItem.fileName;
      this.editFile.size = this.editedItem.fileSize;
      this.uploadedFiles.push(this.editFile);
      documentUsers(this.editedItem.documentID)
        .then(response => {
          this.editedItem.userID = response.data;
          this.loader = false;
        })
        .catch(error => {
          this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });

      this.uploadFile = true;
    },
    showFiles (item) {
      this.folderFfilter = true;
      this.folderName = item.value;
      this.documents = this.allFiles.filter(f => f.departmentID == item.value);
      this.view = 'list';
    },
    formateDate (string) {
      return string ? new Date(string).toLocaleDateString() : '';
    },


  }
};
</script>
<style lang="stylus" scoped>
.media {
  &-cotent--wrap, &-menu {
    min-width: 260px;
    border-right: 1px solid #eee;
    min-height: calc(100vh - 50px - 64px);
  }

  &-detail {
    min-width: 300px;
    border-left: 1px solid #eee;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Media.vue